module.exports = __webpack_public_path__ + "img/meta2026.e0b85d10.jpg";